import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import { CheckIcon } from 'src/assets/icons/CheckIcon';
import { mediaQuery } from 'src/assets/media-query-config';
import { easeTransform } from 'src/domains/layouts/shared/animation/AnimationAndTransition.style';
import { Label } from 'src/domains/layouts/shared/typography/Content.style';

export const SectionLabel = styled(Label, { label: 'SectionLabel' })`
    font-weight: ${fontWeight.bold};
`;

export const ColorSelectOption = styled('p', { label: 'ColorSelectOption' })`
    font-family: var(--fontFamilyPrimary);
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.medium};
    color: ${mainColors.main.primary};
    margin: 0;
`;

export const ColorPickersWrapper = styled('div', { label: 'ColorPickersWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    margin-right: 16px;

    @media ${mediaQuery.xLargeDesktop} {
        flex-flow: row nowrap;
        justify-content: space-between;
    }
`;

export const ColorPickerWrapper = styled('div', { label: 'ColorPickerWrapper' })`
    &:first-of-type {
        margin-bottom: 16px;
    }
    @media ${mediaQuery.xLargeDesktop} {
        flex: 0 0 50%;
        width: 50%;

        &:not(:first-of-type) {
            margin-left: 16px;
        }
    }
`;

export const ColorPaletteWrapper = styled('div', { label: 'ColorPaletteWrapper' })`
    display: flex;
    flex-flow: row wrap;
    margin-top: 4px;
`;

export const ColorOptionWrapper = styled('div', { label: 'ColorOptionWrapper' })`
    position: relative;
    display: flex;
    align-items: center;
    margin: 0 4px 4px 0;
    &:last-of-type{
        margin-right: 0;
    }
`;

interface ColorOptionPropsType {
    isChecked?: boolean,
    color: string,
}

export const buildCheckboxType = (isChecked: boolean | undefined, color: string): string => {
    if (isChecked === true) {
        return `
            border: solid 2px ${mainColors.main.secondary};
            background: ${color};
        `;
    }
    return `
        border: solid 1px ${mainColors.grays.gray400};
        background: ${color};
    `;
};

export const ColorOption = styled('span', { label: 'ColorOption' })<ColorOptionPropsType>`
    position: relative;
    align-items: center;
    display: flex;
    justify-content: center;
    flex: 0 0 16px;
    width: 16px;
    height: 16px;
    transition: background-color .2s ease;
    ${(props): string => buildCheckboxType(props.isChecked, props.color)};
    border-radius: 4px;
`;

interface CheckIconPropsType {
    isChecked: boolean,
}

export const CheckIconWrapper = styled(CheckIcon, { label: 'CheckIconWrapper' })<CheckIconPropsType>`
    position: absolute;
    width: 10px;
    fill: ${mainColors.default.light};
    filter: drop-shadow(1px 2px 2px rgba(66, 68, 90, 1));
    transform: ${(props): string => props.isChecked ? 'scale(1)' : 'scale(0)'};
    transition: ${easeTransform};
`;
